"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const react_native_1 = require("react-native");
const Breakpoints_1 = require("../../../../../helper/Breakpoints");
exports.styles = react_native_1.StyleSheet.create({
    rectanglePremium: {
        borderWidth: 4,
        borderColor: '#3db384',
        width: 450,
        height: 'auto',
        backgroundColor: '#3db384',
        alignItems: 'center',
        textAlign: 'center',
        padding: 5,
        marginVertical: 5,
        shadowRadius: 5,
        shadowOpacity: 0.2,
    },
    image: {
        marginVertical: 15,
        flex: 1,
        resizeMode: 'contain',
        tintColor: '#fff',
    },
    positionLeft: {
        position: 'absolute',
        left: 0,
    },
    positionRight: {
        position: 'absolute',
        right: 0,
    },
    pharmacyDescription: {
        marginVertical: 20,
        lineHeight: 30,
        margin: 10,
        color: 'white',
        fontSize: 15,
    },
    starStyles: {
        marginHorizontal: 0.8,
    },
    buttonRow: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    ratingRow: {
        flexDirection: 'row',
        paddingHorizontal: 50,
        width: '95%',
        marginBottom: 20,
        color: '#e3e3e3',
    },
    offWhiteColor: {
        color: '#e3e3e3',
    },
    detailsLine: {
        borderTopColor: '#e3e3e3',
        borderTopWidth: 1,
        width: '98%',
        marginVertical: 10,
    },
    divider: {
        borderTopColor: '#e0e0e0',
        borderBottomColor: '#e0e0e0',
        borderBottomWidth: 1,
        borderTopWidth: 1,
        borderRadius: 0,
        marginBottom: 10,
        marginTop: 5,
        padding: 5,
        width: 'auto',
        paddingVertical: 15,
    },
    buttonText: {
        fontSize: 12,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: '#fff',
    },
    buttonTextGreen: {
        fontSize: 12,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: '#3db384',
    },
    buttonTextGreenDisabled: {
        fontSize: 12,
        lineHeight: 21,
        letterSpacing: 0.25,
        color: '#fff',
    },
    button: {
        alignItems: 'center',
        backgroundColor: 'transparent',
        paddingVertical: 8,
        paddingHorizontal: 30,
        marginHorizontal: 15,
        marginVertical: 10,
        marginLeft: 50,
        borderRadius: 25,
        alignSelf: !Breakpoints_1.isMobileOrTablet ? undefined : 'center',
        width: !Breakpoints_1.isMobileOrTablet ? 'fit-content' : undefined,
        overflow: 'hidden',
        borderColor: '#fff',
        borderWidth: 1,
        borderStyle: 'solid',
    },
    buttonGreen: {
        alignItems: 'center',
        backgroundColor: '#fff',
        paddingVertical: 8,
        paddingHorizontal: 30,
        marginHorizontal: 15,
        marginVertical: 10,
        borderRadius: 25,
        marginRight: 50,
        alignSelf: react_native_1.Platform.OS === 'web' ? undefined : 'center',
        width: react_native_1.Platform.OS === 'web' ? 'fit-content' : undefined,
        overflow: 'hidden',
    },
    buttonGreenDisabled: {
        alignItems: 'center',
        backgroundColor: '#c1c1c1',
        paddingVertical: 8,
        paddingHorizontal: 30,
        marginHorizontal: 15,
        marginVertical: 10,
        borderRadius: 25,
        marginRight: 50,
        alignSelf: react_native_1.Platform.OS === 'web' ? undefined : 'center',
        width: react_native_1.Platform.OS === 'web' ? 'fit-content' : undefined,
        overflow: 'hidden',
    },
});
